import React from 'react';

const Blogs = () => {
    return (
        <div className='mt-5'>
            <div className="card w-3/4 mx-auto bg-gray-600 text-primary-conten shadow-md text-white m-10">
                <div className="card-body">
                    <h2 className="card-title">Q1:What is the purpose of react router?</h2>
                    <p>Ans : React Router is a standard library for routing in React. It enables the navigation among views of various components in a React Application, allows changing the browser URL, and keeps the UI in sync with the URL</p>
                </div>
            </div>
            <div className="card w-3/4 mx-auto bg-gray-600 text-primary-conten shadow-md text-white m-10">
                <div className="card-body">
                    <h2 className="card-title">Q2:How does context Api work?</h2>
                    <p>Ans : The React Context API is a way for a React app to effectively produce global variables that can be passed around. This is the alternative to "prop drilling" or moving props from grandparent to child to parent, and so on. Context is also touted as an easier, lighter approach to state management using Redux.</p>
                </div>
            </div>
            <div className="card w-3/4 mx-auto bg-gray-600 text-primary-conten shadow-md text-white m-10">
                <div className="card-body">
                    <h2 className="card-title">Q3:What is useref in react?</h2>
                    <p>Ans : Essentially, useRef is like a “box” that can hold a mutable value in its .current property. You might be familiar with refs primarily as a way to access the DOM. If you pass a ref object to React with  , React will set its .current property to the corresponding DOM node whenever that node changes.</p>
                </div>
            </div>
        </div>
    );
};

export default Blogs;